import { Answer, Answers, GetTotalInput_Question, Question, Questions, SurveySection } from "models";

export const COMPANIES_SELECTION_QUESTION = '1.10.20';

export class SurveyUtility {

    static getPrevQuestion(fQuestion: Question, fQuestions: Questions): Question {
        let i = fQuestions.findIndex(x => x.id == fQuestion.id) - 1;
        while(i > -1) {
            const q = fQuestions[i];

            if (q.dependentOn != null) {
                const depAnswer = this.getAnswerById(q.dependentOn, fQuestions);
                if (depAnswer.isSelected) { return q }
            }
            else { return q }

            i--;
        }

        return null
    }

    static getNextQuestion(fQuestion: Question, fQuestions: Questions): Question {
        let i = fQuestions.findIndex(x => x.id == fQuestion.id) + 1;
        while (i < fQuestions.length) {
            const q = fQuestions[i];

            if (q.dependentOn != null) {
                const depAnswer = this.getAnswerById(q.dependentOn, fQuestions);
                if (depAnswer.isSelected) { return q }
            }
            else { return q }

            i++;
        }

        return null
    }

    static getQuestionOfAnswer(answerCode: string, fQuestions: Questions): Question {
        const qCode = answerCode.split('-')[0];
        return fQuestions.find(x => x.id == qCode);
    }

    static getSelectedAnswerOfQuestion(fQuestion: Question): Answer {
        if (fQuestion) {
            return fQuestion.answers.find(a => a.isSelected)
        }

        return undefined
    }

    static getAnswers(fQuestions: Questions): Answers {
        return fQuestions.reduce((answers, question) => {
            answers = answers.concat(question.answers);
            return answers
        }, [])
    }

    static getAnswerById(answerId: string, fQuestions: Questions): Answer {
        const answers: Answers = fQuestions.reduce((rit, currQ) => {
            rit = rit.concat(currQ.answers);
            return rit
        }, [])
        return answers.find(x => x.id == answerId)
    }

    static isQuestionAnswered(fQuestion: Question): boolean {
        return fQuestion.answers.findIndex(x => x.isSelected) > -1
    }

    static isQuestionHidden(fQuestion: Question, fQuestions: Questions): boolean {
        const isQAnswered = this.isQuestionAnswered(fQuestion);
        const isPrevQAnswered = fQuestion.prevQuestion ? this.isQuestionAnswered(fQuestion.prevQuestion) : true;
        let isDepAnswerSelected = true;
        if (fQuestion.dependentOn != null) {
            const depAnswer = this.getAnswerById(fQuestion.dependentOn, fQuestions);
            isDepAnswerSelected = depAnswer.isSelected;
        }        

        return !((isQAnswered || isPrevQAnswered) && isDepAnswerSelected)
    }

    static getLastQuestionToAnswer(fQuestions: Questions): Question {
      let q: Question = fQuestions[0];
      while (q) {
        if (!q.isHidden && !SurveyUtility.isQuestionAnswered(q)) return q
        q = q.nextQuestion;
      }
      
      return undefined
    }

    static isSectionComplete(fSection: SurveySection): boolean {
        if (!fSection) return false

        let q = fSection.questions[0];
        while (q != null && this.getSectionIdOfQuestion(q.id) == fSection.id) {
            if (!this.isQuestionAnswered(q)) return false
            q = q.nextQuestion;
        }

        return true
    }

    static getLastQuestionWithAnswer(fQuestions: Questions): Question {
        let _question: Question = undefined;

        if (fQuestions) {
            _question = fQuestions.reduce((lastQ, q) => {
                if (this.isQuestionAnswered(q)) {
                    lastQ = q;
                }

                return lastQ
            }, undefined)
        }

        return _question
    }

    static getSectionQuestions(fSection: SurveySection, fQuestions: Questions): Questions {
        if (!fSection || !fQuestions) return undefined
        return fQuestions?.filter(q => q.id.split('.')[0] == fSection.id);
    }

    static getSectionIdOfQuestion(fQuestionId: string): string {
        return fQuestionId.split('.')[0]
    }

}